import {FeedbackType, type MergedFeedback} from "@khan/guide-types";

/**
 * Merge feedback.
 */
export const mergeFeedback = (
    previousFeedback: undefined | null | Readonly<MergedFeedback>,
    newFeedback: Readonly<MergedFeedback>,
): Readonly<MergedFeedback> => {
    // If there's no previous feedback, we just want the new feedback.
    if (!previousFeedback) {
        return {...newFeedback};
    }

    // Merge `newFeedback` with `previousFeedback`, preferring any fields
    // present in `newFeedback`.
    const updatedFeedback: MergedFeedback = {
        ...previousFeedback,
        type: newFeedback.type,
        positive: newFeedback.positive,
    };

    switch (newFeedback.type) {
        case FeedbackType.Quick:
            updatedFeedback.sentiment = newFeedback.sentiment;
            break;
        case FeedbackType.General:
            updatedFeedback.reaction = newFeedback.reaction;
            updatedFeedback.note = newFeedback.note;
            break;
        case FeedbackType.Negative:
        case FeedbackType.Positive:
            updatedFeedback.reaction = newFeedback.reaction;
            updatedFeedback.note = newFeedback.note;
            updatedFeedback.rewrittenResponse = newFeedback.rewrittenResponse;
            break;
    }
    return updatedFeedback as Readonly<MergedFeedback>;
};
